<!-- ▼ 印刷時のみ表示 ここから -->
<div class="problem-detail-show-print-only-wrapper" data-print-only *ngIf="(problem$ | async)?.examPaper">
  <app-problem-detail-frame-for-print
    [menuType]="menuType$ | async"
    [staticCommonData]="staticCommonData$ | async"
    [readableScienceProblems]="readableScienceProblems$ | async"
    [readableEnglishProblems]="readableEnglishProblems$ | async"
    [readableNationalLanguageProblems]="readableNationalLanguageProblems$ | async"
    [readableJapaneseHistoryProblems]="readableJapaneseHistoryProblems$ | async"
    [readableWorldHistoryProblems]="readableWorldHistoryProblems$ | async"
    [paperMode]="paperMode$ | async"
    [trialMode]="trialMode$ | async"
    [subjectId]="subjectId$ | async"
    [isBToC]="true"
  ></app-problem-detail-frame-for-print>
</div>
<!-- △ 印刷時のみ表示 ここまで -->
<!-- ▼ 印刷時は消す ここから -->
<app-content-row data-no-print>
  <div class="fluct-banner-area">
    <ng-container *ngTemplateOutlet="fluctBanners"></ng-container>
  </div>

  <app-content-row>
    <app-content-row>
      <app-content-row>
        <div data-no-print>
          <div *ngIf="!isPreconditionError">
            <div [@fadeInOut]="(searching$ | async) === false">
              <!-- ▼ 「大学名」の一覧を見るボタン -->
              <app-content-row>
                <app-overflow-wrapper-x>
                  <app-wrapper size="xl" data-no-print>
                    <button mat-flat-button class="button-check-list text-primary" (click)="goUniversityDetail()">
                      {{ universityName$ | async }}({{ year$ | async }}年) の一覧 を見る
                      <!-- 長い大学名長い大学名長い大学名長い大学名長い大学名長い大学名 の一覧を見る -->
                    </button>
                  </app-wrapper>
                </app-overflow-wrapper-x>
              </app-content-row>
              <!-- △ 「大学名」の一覧を見るボタン -->

              <app-content-row *ngIf="(problem$ | async)?.hasExternalData && (isVisible$ | async); else noExternalData">
                <app-wrapper size="xl" isFitWithSmallScreen="true">
                  <!-- ▼ テスト表示領域 -->
                  <app-problem-detail-frame
                    [staticCommonData]="staticCommonData$ | async"
                    [readableScienceProblems]="readableScienceProblems$ | async"
                    [readableEnglishProblems]="readableEnglishProblems$ | async"
                    [readableNationalLanguageProblems]="readableNationalLanguageProblems$ | async"
                    [readableJapaneseHistoryProblems]="readableJapaneseHistoryProblems$ | async"
                    [readableWorldHistoryProblems]="readableWorldHistoryProblems$ | async"
                    [paperMode]="paperMode$ | async"
                    [trialMode]="trialMode$ | async"
                    [canDisplay]="canDisplay$ | async"
                    [showPaperBookmarkBtn]="showPaperBookmarkBtn"
                    [subjectId]="subjectId$ | async"
                    [canBookmarkSpinner]="true"
                    [isPaperBookmarked]="isPaperBookmarked"
                    (menuTypeChangeHandler)="changeMenuType($event)"
                    (printClickHandler)="showPrint()"
                    (addPaperBookmarkClick)="addPaperBookmark()"
                    (deletePaperBookmarkClick)="deletePaperBookmark()"
                    (openAnsweredDialogClick)="openAnsweredDialog()"
                  ></app-problem-detail-frame>
                  <!-- △ テスト表示領域 -->
                </app-wrapper>
              </app-content-row>
            </div>

            <div class="progress-48" [@fadeInOut]="searching$ | async">
              <mat-spinner [diameter]="48"></mat-spinner>
            </div>
          </div>

          <ng-template #noExternalData>
            <div class="text-center text-nega">
              <app-problem-detail-no-external-data></app-problem-detail-no-external-data>
            </div>
          </ng-template>
        </div>
      </app-content-row>
    </app-content-row>
  </app-content-row>

  <div class="fluct-banner-area">
    <ng-container *ngTemplateOutlet="fluctBanners"></ng-container>
  </div>
</app-content-row>
<!-- △ 印刷時は消す ここまで -->

<ng-template #fluctBanners>
  <div size="xl" data-no-print *ngIf="isShowFluctBanners">
    <!-- test用 -->
    <div class="fluct-unit-1000305718-1 ad-unit ad-unit-pr"></div>
    <!-- prod用 -->
    <div class="fluct-unit-1000305716-1 ad-unit ad-unit-pr"></div>

    <!-- test用 -->
    <div class="fluct-unit-1000305714-1 ad-unit ad-unit-pr"></div>
    <!-- prod用 -->
    <div class="fluct-unit-1000305712-1 ad-unit ad-unit-pr"></div>
  </div>
</ng-template>
